import { ApiPlugin } from './api-plugins';

// === Generate a random 64-bit number in fixed-length hex format
// Via zipkin:
// https://github.com/openzipkin/zipkin-js/blob/ec89188cf6a07e184ab886c1dfb6c9dc276ddfa4/packages/zipkin/src/tracer/randomTraceId.js
function randomTraceId() {
  const digits = '0123456789abcdef';
  let n = '';
  for (let i = 0; i < 16; i += 1) {
    const rand = Math.floor(Math.random() * 16);
    n += digits[rand];
  }
  return n;
}

class TracerPlugin extends ApiPlugin {
  static before(config) {
    config.headers ||= {};
    const id = randomTraceId();
    config.headers['X-B3-SpanId'] = id;
    config.headers['X-B3-TraceId'] = id;
  }
}

export default TracerPlugin;
